module.exports = __webpack_public_path__ + "static/assets/ca8b09aa5dc63a2eefe49951456aa832.png";